import { DOCUMENT } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LightboxService } from '@shared/services/lightbox.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReplaySubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-lightbox',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './lightbox.component.html',
  styleUrl: './lightbox.component.scss',
  providers: [BsModalService],
})
export class LightboxComponent {
  imageUrl: any;
  lightboxOpen: boolean = false;
  private subscription: Subscription = new Subscription();
  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);
  modalRef?: BsModalRef;
  @ViewChild('template', { static: true }) template: any;
  constructor(
    private lightboxService: LightboxService,
    @Inject(DOCUMENT) private document: Document,
    private modalService: BsModalService
  ) {
    this.subscription = this.lightboxService.lightboxOpen$.subscribe((open) => {
      this.lightboxOpen = open;
      this.imageUrl = null;
      if (open) {
        this.imageUrl = this.lightboxService.imageUrl;
        if (this.imageUrl) {
          this.showModal();
        }
      }
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private showModal() {
    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-dialog-centered img-modal',
    });
  }

  closeLightbox() {
    this.modalService.hide();
  }

  openLightBox() {}
}
